import * as Styled from '../styled'
import BlockedPermanentlySVG from '~components/svgs/BlockedPermanently'
import { urlHandler } from '~utils/path'
import { useRequest } from 'ahooks'
import { Auth } from '~services'
import { Issues } from '../interfaces'

function BlockedPermanently() {
  const url = process.env.REACT_APP_FRETEBRAS_SITE
  const termsOfUseUrl = `${url}/termos-de-uso`
  const helpCenter = 'https://fretebras-caminhoneiro.zendesk.com/hc/pt-br'
  const { loading, runAsync: logout } = useRequest(Auth.logout, { manual: true })

  useRequest<Issues, []>(Auth.issues, {
    onSuccess: handleSuccessIssues,
  })

  async function handleLogout() {
    await logout()
    window.open(urlHandler(`${url}/tipo-de-cadastro?q=entrar`), '_self')
  }

  function handleSuccessIssues(data: Issues) {
    if (!data) {
      window.open(`${url}/fretes`, '_self')
      return
    }
    if (data.redirect !== location.pathname) window.open(data.redirect, '_self')
  }

  return (
    <Styled.Wrapper role="region">
      <BlockedPermanentlySVG />

      <Styled.Title>
        Sua conta foi desativada permanentemente
      </Styled.Title>

      <Styled.TermsText>
        Identificamos que sua conta está em desconformidade com nossos{' '}
        <Styled.Link href={urlHandler(termsOfUseUrl)} target="_blank">
          <Styled.HighlightedText>
            Termos de uso
          </Styled.HighlightedText>
        </Styled.Link>
        {' '} e, por isso, você não poderá mais acessar a plataforma Fretebras.
      </Styled.TermsText>

      <Styled.Text>
        Caso queira entender melhor a situação, voce pode consultar o Item VIII dos{' '}
        <Styled.Link href={urlHandler(termsOfUseUrl)} target="_blank">
            <Styled.HighlightedText>
              Termos de Uso da Fretebras
            </Styled.HighlightedText>
          </Styled.Link>
          (Bloqueio e Desativação de Cadastro de Usuário), ou entrar em contato conosco através dos canais de comunicação disponíveis em {' '}
        <Styled.Link href={urlHandler(helpCenter)} target="_blank">
          <Styled.HighlightedText>
            nosso site.
          </Styled.HighlightedText>
        </Styled.Link>
      </Styled.Text>

      <Styled.BottomButton color="primary" onClick={handleLogout} loading={loading}>
        Sair da conta
      </Styled.BottomButton>
    </Styled.Wrapper>
  )
}

export default BlockedPermanently
